import React from "react";
import {createRoot, hydrateRoot} from "react-dom/client";
import {loadableReady} from '@loadable/component';
import App from './app';
import {dynamicImport, preloadComponent} from './app/helpers/common';

const removeSSRStyles = () => {
    if (document.getElementById('jss-server-side')) {
        document.getElementById('jss-server-side').remove();
    }

    if (document.getElementById('jss-server-side-2')) {
        document.getElementById('jss-server-side-2').remove();
    }
};

if (document.getElementById('app')) {
    const container = document.getElementById('app');

    loadableReady(() => {
        if (window.location.pathname === '/' || window.location.pathname === '/FCXgwtzDII') {
            const Home = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Home" */ './app/views/app/Home'));
            Home.load().then(() => {
                removeSSRStyles();
                // createRoot(container).render(<App />);
                hydrateRoot(container, <App location={window.location.pathname} />);
            });
        } else if (window.location.pathname === '/app/housing-questionnaire') {
            const RangeSlider = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "RangeSlider" */ './app/components/forms/components/MaterialUIRangeSlider'));
            preloadComponent(RangeSlider);

            const Questionnaire = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Questionnaire" */ './app/views/app/Questionnaire'));
            Questionnaire.load().then(() => {
                removeSSRStyles();
                createRoot(container).render(<App />);
            });
        } else {
            removeSSRStyles();
            createRoot(container).render(<App />);
        }
    });
}

